// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schs-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  overflow-y: auto;
  padding: 20px;
}

.schs-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 20px;
}

.schs-filters-left {
  display: flex;
  gap: 24px;
  align-items: center;
  flex-wrap: wrap;
}

.schs-filter-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.schs-filter-label {
  font-size: 14px;
  font-weight: 500;
  color: #002FA7;
}

.schs-filter-select {
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  color: #1f2937;
}

.schs-filter-select:focus {
  outline: none;
  border-color: #002FA7;
}

.schs-semester-buttons {
  display: flex;
  gap: 8px;
}

.schs-semester-btn {
  padding: 8px 20px;
  border: 1px solid #e2e8f0;
  background: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.3s ease;
}

.schs-semester-btn:hover {
  border-color: #002FA7;
  color: #002FA7;
}

.schs-semester-btn.active {
  background: #002FA7;
  color: white;
  border-color: #002FA7;
}

.schs-doc-buttons {
  display: flex;
  gap: 8px;
}

.schs-export-btn,
.schs-print-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  border: 1px solid #8aa3c4b8;
  background: white;
  color: #002FA7;
}

.schs-export-btn:hover,
.schs-print-btn:hover {
  transform: translateY(-1px);
}

.schs-print-btn {
  margin-left: 8px;
}

.schs-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.schs-stat-card {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
}

.schs-stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.schs-stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #002FA7;
  margin-bottom: 8px;
}

.schs-stat-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.schs-categories {
  margin-bottom: 24px;
}

.schs-categories-title {
  font-size: 18px;
  font-weight: 600;
  color: #002FA7;
  margin-bottom: 16px;
}

.schs-categories-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.schs-category-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.schs-category-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.category-header {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: white;
}

.schs-category-name {
  flex: 1 1;
  font-size: 13px;
}

.category-count {
  background: rgba(255, 255, 255, 0.3);
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 12px;
}

.excellent-category .category-header { background: #002FA7; }
.goodexcellent-category .category-header { background: #002FA7; }
.good-category .category-header { background: #002FA7; }
.none-category .category-header { background: #002FA7; opacity: 0.4; }

.category-list {
  max-height: 510px;
  overflow-y: auto;
  background: white;
  border: 1px solid #e2e8f0;
  border-top: none;
}

.category-student {
  padding: 10px 16px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: background 0.2s ease;
  font-size: 14px;
  color: #1f2937;
}

.category-student:hover {
  background: #f8fafc;
}

.category-empty {
  padding: 20px;
  text-align: center;
  color: #9ca3af;
  font-size: 13px;
}

.schs-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: #64748b;
}

.schs-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: schs-fadeIn 0.2s ease;
}

@keyframes schs-fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.schs-student-details-modal {
  width: 500px;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  animation: schs-slideUp 0.3s ease;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

@keyframes schs-slideUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

.schs-modal-header {
  padding: 20px 24px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.schs-modal-header h3 {
  margin: 0;
  color: white;
  font-size: 20px;
  font-weight: 600;
}

.schs-modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  font-size: 20px;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.schs-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.schs-student-details {
  padding: 24px;
}

.detail-row {
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.detail-row:last-child {
  margin-bottom: 0;
}

.detail-label {
  width: 140px;
  font-weight: 500;
  color: #64748b;
  font-size: 14px;
  flex-shrink: 0;
}

.detail-value {
  flex: 1 1;
  color: #1f2937;
  font-size: 15px;
  font-weight: 500;
}

.scholarship-type-excellent {
  color: #f59e0b;
  font-weight: 600;
}

.scholarship-type-good-excellent {
  color: #10b981;
  font-weight: 600;
}

.scholarship-type-good {
  color: #3b82f6;
  font-weight: 600;
}

.scholarship-type-none {
  color: #ef4444;
  font-weight: 600;
}

@media (max-width: 1024px) {
  .schs-categories-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  
  .schs-stats {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
}

@media (max-width: 768px) {
  .schs-container {
    padding: 16px;
  }
  
  .schs-filters {
    flex-direction: column;
    align-items: stretch;
  }
  
  .schs-filters-left {
    flex-direction: column;
    align-items: stretch;
  }
  
  .schs-filter-group {
    justify-content: space-between;
  }
  
  .schs-semester-buttons {
    flex: 1 1;
    justify-content: flex-end;
  }
  
  .schs-doc-buttons {
    justify-content: flex-end;
  }
  
  .schs-stats {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}

@media (max-width: 640px) {
  .schs-categories-grid {
    grid-template-columns: 1fr;
  }
  
  .schs-stats {
    grid-template-columns: 1fr;
  }
  
  .schs-student-details-modal {
    width: 90%;
    margin: 16px;
  }
  
  .detail-row {
    flex-direction: column;
    gap: 6px;
  }
  
  .detail-label {
    width: auto;
  }
  
  .schs-modal-header h3 {
    font-size: 18px;
  }
  
  .schs-export-btn,
  .schs-print-btn {
    flex: 1 1;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/dh-components/ScholarshipSectionStyle.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,uCAAuC,mBAAmB,EAAE;AAC5D,2CAA2C,mBAAmB,EAAE;AAChE,kCAAkC,mBAAmB,EAAE;AACvD,kCAAkC,mBAAmB,EAAE,YAAY,EAAE;;AAErE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,SAAO;IACP,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,SAAO;IACP,kBAAkB;EACpB;AACF","sourcesContent":[".schs-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.schs-filters {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #e2e8f0;\n  margin-bottom: 20px;\n}\n\n.schs-filters-left {\n  display: flex;\n  gap: 24px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.schs-filter-group {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.schs-filter-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #002FA7;\n}\n\n.schs-filter-select {\n  padding: 8px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  background: white;\n  cursor: pointer;\n  color: #1f2937;\n}\n\n.schs-filter-select:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n.schs-semester-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.schs-semester-btn {\n  padding: 8px 20px;\n  border: 1px solid #e2e8f0;\n  background: white;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.schs-semester-btn:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n.schs-semester-btn.active {\n  background: #002FA7;\n  color: white;\n  border-color: #002FA7;\n}\n\n.schs-doc-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.schs-export-btn,\n.schs-print-btn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n  border: 1px solid #8aa3c4b8;\n  background: white;\n  color: #002FA7;\n}\n\n.schs-export-btn:hover,\n.schs-print-btn:hover {\n  transform: translateY(-1px);\n}\n\n.schs-print-btn {\n  margin-left: 8px;\n}\n\n.schs-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.schs-stat-card {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 16px;\n  text-align: center;\n  border: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n}\n\n.schs-stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.schs-stat-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: #002FA7;\n  margin-bottom: 8px;\n}\n\n.schs-stat-label {\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.schs-categories {\n  margin-bottom: 24px;\n}\n\n.schs-categories-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #002FA7;\n  margin-bottom: 16px;\n}\n\n.schs-categories-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n}\n\n.schs-category-card {\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s ease;\n}\n\n.schs-category-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.category-header {\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  color: white;\n}\n\n.schs-category-name {\n  flex: 1;\n  font-size: 13px;\n}\n\n.category-count {\n  background: rgba(255, 255, 255, 0.3);\n  padding: 2px 8px;\n  border-radius: 20px;\n  font-size: 12px;\n}\n\n.excellent-category .category-header { background: #002FA7; }\n.goodexcellent-category .category-header { background: #002FA7; }\n.good-category .category-header { background: #002FA7; }\n.none-category .category-header { background: #002FA7; opacity: 0.4; }\n\n.category-list {\n  max-height: 510px;\n  overflow-y: auto;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-top: none;\n}\n\n.category-student {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  font-size: 14px;\n  color: #1f2937;\n}\n\n.category-student:hover {\n  background: #f8fafc;\n}\n\n.category-empty {\n  padding: 20px;\n  text-align: center;\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n.schs-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n  color: #64748b;\n}\n\n.schs-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: schs-fadeIn 0.2s ease;\n}\n\n@keyframes schs-fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.schs-student-details-modal {\n  width: 500px;\n  background: white;\n  border-radius: 20px;\n  overflow: hidden;\n  animation: schs-slideUp 0.3s ease;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n@keyframes schs-slideUp {\n  from { opacity: 0; transform: translateY(30px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.schs-modal-header {\n  padding: 20px 24px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.schs-modal-header h3 {\n  margin: 0;\n  color: white;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.schs-modal-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  font-size: 20px;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.schs-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.schs-student-details {\n  padding: 24px;\n}\n\n.detail-row {\n  margin-bottom: 20px;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.detail-row:last-child {\n  margin-bottom: 0;\n}\n\n.detail-label {\n  width: 140px;\n  font-weight: 500;\n  color: #64748b;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.detail-value {\n  flex: 1;\n  color: #1f2937;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.scholarship-type-excellent {\n  color: #f59e0b;\n  font-weight: 600;\n}\n\n.scholarship-type-good-excellent {\n  color: #10b981;\n  font-weight: 600;\n}\n\n.scholarship-type-good {\n  color: #3b82f6;\n  font-weight: 600;\n}\n\n.scholarship-type-none {\n  color: #ef4444;\n  font-weight: 600;\n}\n\n@media (max-width: 1024px) {\n  .schs-categories-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n  \n  .schs-stats {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n  }\n}\n\n@media (max-width: 768px) {\n  .schs-container {\n    padding: 16px;\n  }\n  \n  .schs-filters {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .schs-filters-left {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .schs-filter-group {\n    justify-content: space-between;\n  }\n  \n  .schs-semester-buttons {\n    flex: 1;\n    justify-content: flex-end;\n  }\n  \n  .schs-doc-buttons {\n    justify-content: flex-end;\n  }\n  \n  .schs-stats {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n}\n\n@media (max-width: 640px) {\n  .schs-categories-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .schs-stats {\n    grid-template-columns: 1fr;\n  }\n  \n  .schs-student-details-modal {\n    width: 90%;\n    margin: 16px;\n  }\n  \n  .detail-row {\n    flex-direction: column;\n    gap: 6px;\n  }\n  \n  .detail-label {\n    width: auto;\n  }\n  \n  .schs-modal-header h3 {\n    font-size: 18px;\n  }\n  \n  .schs-export-btn,\n  .schs-print-btn {\n    flex: 1;\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
